module.exports = __webpack_public_path__ + "media/images/favicons/favicon-32x32-170624b52ded660486fd70f806ce4287.png";